// extracted by mini-css-extract-plugin
export default {"payment":"payment--OXoxt"};